// extracted by mini-css-extract-plugin
export default {"container":"ActuPage_container__lC5HS","title":"ActuPage_title__O0Wsp"};